import { useCallback, useEffect, useState } from 'react';

export type Theme = 'dark' | 'light';

const STORAGE_KEY = 'openflow.theme';
const DEFAULT_THEME: Theme = 'dark';

/** 저장된 테마를 읽는다. 없거나 접근 불가(프라이빗 창 등)면 기본값(dark). */
export function getInitialTheme(): Theme {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'dark' || v === 'light') return v;
  } catch {
    /* localStorage 접근 불가 — 기본값 사용 */
  }
  return DEFAULT_THEME;
}

/** <html class="dark"> 토글 + 저장. Tailwind darkMode:'class' 와 index.css 의 .dark 변수가 이 클래스를 본다. */
export function applyTheme(theme: Theme): void {
  document.documentElement.classList.toggle('dark', theme === 'dark');
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* 저장 실패는 무시 — 이번 세션에는 적용된다 */
  }
}

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(getInitialTheme);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme(t => (t === 'dark' ? 'light' : 'dark'));
  }, []);

  return { theme, setTheme, toggle, isDark: theme === 'dark' };
}
